import React from 'react'
import {ICONS} from '../../../components'
import {AudioList} from './TokenAudioPlayer'
import styles from './TokenDisplay.module.css'

export type Token = {
    token_number: string
    first_name: string
    last_name: string
    category: 'mac' | 'ios' | 'delivery'
    counter_number?: string
    technician_name?: string
    url: string
    token_voice_url: string
    counter_voice_url: string
}

interface TokenDisplayProps {
    tokens: Token[]
    currentDisplayToken?: Token
}

enum CategoryDisplayNames {
    mac = 'MacBook/Mac/MacPro',
    ios = 'iPhone/iPad/Watch/Accessories',
    delivery = 'Delivery',
}

const TokenDisplay: React.FC<TokenDisplayProps> = ({tokens, currentDisplayToken}) => {
    const getCategoryName = (value: Token['category']): string =>
        CategoryDisplayNames[value] || value

    const getRowClass = (token: Token): string =>
        token.counter_number ? styles.rowWithCounter : styles.rowWithoutCounter

    const tokenRows: JSX.Element[] = []
    for (let i = 0; i < tokens?.length; i++) {
        const token = tokens[i]
        tokenRows.push(
            <tr key={token.url} className={getRowClass(token)}>
                <td className="text-center">
                    <span className="scoreboard">{token.token_number.toString().padStart(2, '0')}</span>
                </td>
                <td className="text-center text-capitalize">{token.first_name} {token.last_name}</td>
                <td className="text-center">{getCategoryName(token.category)}</td>
                <td className="text-center">
                    {token.counter_number ? (
                        <span>{token.counter_number.padStart(2, '0')}</span>
                    ) : (
                        <span>
              Waiting <span className={styles.dot}>.</span>
              <span className={styles.dot}>.</span>
              <span className={styles.dot}>.</span>
            </span>
                    )}
                </td>
                <td className="text-center text-capitalize">{token.technician_name || ICONS.WAITING}</td>
                <td className="text-center">
                    <h3 className="text-success">{token.counter_number ? ICONS.CHECKED : ICONS.WAITING}</h3>
                </td>
            </tr>
        )
    }

    return (
        <>
            <div className="pt-5 table-responsive">
                <table style={{background: "white"}} className={`table`}>
                    <thead className={styles.headerRow}>
                    <tr>
                        <th className="text-center">Token</th>
                        <th>Customer Name</th>
                        <th>Product</th>
                        <th>Counter</th>
                        <th>Called By</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>{tokenRows}</tbody>
                </table>
            </div>

            {currentDisplayToken && (
                <AudioList
                    list={[
                        currentDisplayToken.token_voice_url,
                        currentDisplayToken.counter_voice_url,
                    ]}
                />
            )}
        </>
    )
}

export default TokenDisplay
